define("settings/templates/groups/group/contributors/new", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{action (perform this.handleClose this.email)}} as |modal|>
    <modal.card @portrait="true">
      <modal.card-header @title={{t "shared_phrases.invite_contributor"}} />
      <ModalForm @cancel={{modal.close}} @task={{task this.handleSubmit this.email}} as |form|>
        <modal.card-body>
          <form.input
            @autocomplete="email"
            @autofocus={{true}}
            @label={{t "shared_words.email"}}
            @placeholder={{t "account.groups.group.contributors.new.email_placeholder"}}
            @type="email"
            @value={{this.email}}
          />
        </modal.card-body>
        <modal.card-footer>
          <form.footer @submitButtonText={{t "account.groups.group.contributors.new.submit"}} />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "kw6eczV1",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[28,[37,2],[[30,0,[\"handleClose\"]],[30,0,[\"email\"]]],null]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[\"true\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,3],[\"shared_phrases.invite_contributor\"],null]]],null],[1,\"\\n    \"],[8,[39,4],null,[[\"@cancel\",\"@task\"],[[30,1,[\"close\"]],[28,[37,5],[[30,0,[\"handleSubmit\"]],[30,0,[\"email\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"input\"]],null,[[\"@autocomplete\",\"@autofocus\",\"@label\",\"@placeholder\",\"@type\",\"@value\"],[\"email\",true,[28,[37,3],[\"shared_words.email\"],null],[28,[37,3],[\"account.groups.group.contributors.new.email_placeholder\"],null],\"email\",[30,0,[\"email\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@submitButtonText\"],[[28,[37,3],[\"account.groups.group.contributors.new.submit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"action\",\"perform\",\"t\",\"modal-form\",\"task\"]]",
    "moduleName": "settings/templates/groups/group/contributors/new.hbs",
    "isStrictMode": false
  });
});